import React from 'react';
import styled from 'styled-components';

import ContentfulImage from 'hub/components/ContentfulImage';

const calculateRatioPreservedHeight = ({
  width,
  originalWidth,
  originalHeight,
}) => Math.round((originalHeight / originalWidth) * width);

function SearchLandingPageImage({ fields }) {
  const originalWidth = fields.file.details.image.width;
  const originalHeight = fields.file.details.image.height;

  const width = 720;
  const height = calculateRatioPreservedHeight({
    width,
    originalWidth,
    originalHeight,
  });

  return (
    <ImageWrapper>
      <ContentfulImage
        alt={fields.title}
        width={width}
        height={height}
        src={{ fields }}
        layout="responsive"
      />
    </ImageWrapper>
  );
}

const ImageWrapper = styled.div`
  overflow: hidden;
  border-radius: 8px;
`;

export default SearchLandingPageImage;
